<template>
  <section class="section-review content-padding">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="text-center">{{ $t('message.reviews.reviews_all') }}</h2>
          <h2 class="text-center" style="color:#00ABC2;">{{ $t('message.reviews.professional_service') }}</h2>
        </div>
      </div>

      <div class="mb-5 mt-5" ref="wrap" v-if="reviews && reviews.length > 0">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4" v-for="(item, index) in reviews" :key="`${index}_${item.id}`">
            <review-items :item="item"></review-items>
          </div>
        </div>

        <mugen-scroll v-if="isMoreContents" :handler="loadMore" :should-handle="!loading">
          <template>
            <div class="text-center">
              <img src="/static/img/loader.gif" width="80">
            </div>
          </template>
        </mugen-scroll>
      </div>
      <div v-else>
        <loader/>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import ReviewItems from './components/ReviewItems'
import MugenScroll from 'vue-mugen-scroll'
import loader from '../loader/Loader'

export default {
  name: 'Reviews',
  components: { ReviewItems, MugenScroll, loader },
  data () {
    return {
      page: 0,
      limit: 20,
      reviews: [],
      loading: false,
      isMoreContents: true
    }
  },
  methods: {
    async loadFirstPage () {
      this.page = 0
      this.reviews = []
      this.fetchReviews()
    },
    async loadMore () {
      this.loading = true
      this.page++
      this.fetchReviews()
    },
    async fetchReviews () {
      const { data } = await axios.get('get-reviews-from-user', {
        params: {
          is_show_all: true,
          limit: this.limit,
          page: this.page
        }
      })
      this.loading = false
      if (!data.error) {
        if (this.page > 0) {
          this.isMoreContents = data.professional_reviews.length >= this.limit
          this.reviews.push(...data.professional_reviews)
        } else {
          this.reviews = data.professional_reviews
        }
      } else {
        this.$swal({ text: 'ผิดพลาด ไม่สามารถแสดงรายการรีวิวทั้งหมดได้', type: 'error' })
        console.error('Reviews cannot load : ' + data.message)
      }
    }
  },
  mounted () {
    this.loadFirstPage()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/review/Reviews.vue